import ImgCheckCircleFilled from "./ImgCheckCircleFilled";

export default ImgCheckCircleFilled;



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/ImgCheckCircleFilled/index.js